import * as angular from 'angular';

"use strict";

angular.module('BackButtonModule', [])

export default 'BackButtonModule';
